// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_inputContainer__GyaV-,
.input_inputPassContainer__Kpt\\+I {
  width: 100%;
  position: relative;
}

.input_labelText__iZyAZ {
  margin-bottom: 8px;
  color: var(--black-color);
  
  text-transform: capitalize;
}

.input_inputBox__aCB1V {
  width: 100%;
  background: var(--white-color-v1);
  border: 2px solid rgba(142, 142, 142, 0.45);
  border-radius: 7px;
  height: 46px;
  padding: 15px;
}

.input_rightIconBox__ZYqXh {
  right: 15px;
  top: 8px;
  position: absolute;
}
.input_greenInputBorder__jDv3f {
  border: 2px solid var(--green-color-v1);
}
.input_noBorder__sbyli {
  border: none;
}
.input_rightIconGreen__eZ3xI {
  top: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary-color);
  border-radius: 0px 7px 7px 0px;
  width: 46px;
  height: 46px;
}

.input_inputBox__aCB1V::placeholder {
  font-weight: 600;
}
.input_inputPassContainer__Kpt\\+I .input_passwordIcon__IwA9d {
  position: absolute;
  right: 15px;
  top: 50%;
  bottom: 50%;
  font-size: 20px;
  cursor: pointer;
  transform: translateY(-50%);
  color: #cacaca;
}

.input_errorText__Uuo96 {
  color: #dc3545 !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  margin: 0 !important;
  margin-top: 6px !important;
  line-height: 1.3 !important;
}

`, "",{"version":3,"sources":["webpack://./src/Components/atoms/Input/input.module.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;;EAEzB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,YAAY;AACd;AACA;EACE,QAAQ;EACR,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;AAC7B","sourcesContent":[".inputContainer,\n.inputPassContainer {\n  width: 100%;\n  position: relative;\n}\n\n.labelText {\n  margin-bottom: 8px;\n  color: var(--black-color);\n  \n  text-transform: capitalize;\n}\n\n.inputBox {\n  width: 100%;\n  background: var(--white-color-v1);\n  border: 2px solid rgba(142, 142, 142, 0.45);\n  border-radius: 7px;\n  height: 46px;\n  padding: 15px;\n}\n\n.rightIconBox {\n  right: 15px;\n  top: 8px;\n  position: absolute;\n}\n.greenInputBorder {\n  border: 2px solid var(--green-color-v1);\n}\n.noBorder {\n  border: none;\n}\n.rightIconGreen {\n  top: 0px;\n  right: 0px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--primary-color);\n  border-radius: 0px 7px 7px 0px;\n  width: 46px;\n  height: 46px;\n}\n\n.inputBox::placeholder {\n  font-weight: 600;\n}\n.inputPassContainer .passwordIcon {\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  bottom: 50%;\n  font-size: 20px;\n  cursor: pointer;\n  transform: translateY(-50%);\n  color: #cacaca;\n}\n\n.errorText {\n  color: #dc3545 !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  margin: 0 !important;\n  margin-top: 6px !important;\n  line-height: 1.3 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `input_inputContainer__GyaV-`,
	"inputPassContainer": `input_inputPassContainer__Kpt+I`,
	"labelText": `input_labelText__iZyAZ`,
	"inputBox": `input_inputBox__aCB1V`,
	"rightIconBox": `input_rightIconBox__ZYqXh`,
	"greenInputBorder": `input_greenInputBorder__jDv3f`,
	"noBorder": `input_noBorder__sbyli`,
	"rightIconGreen": `input_rightIconGreen__eZ3xI`,
	"passwordIcon": `input_passwordIcon__IwA9d`,
	"errorText": `input_errorText__Uuo96`
};
export default ___CSS_LOADER_EXPORT___;
